import { useOutletContext } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { ComplaintsDataCollectionItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import AttachmentBox from 'modules/complaints/components/AttachmentBox'
import InternalNotes from 'modules/complaints/components/Complaints/Complaint/Overview/InternalNotes'
import { useComplaintMessages } from 'modules/complaints/hooks/useComplaintMessages'

interface OutletContext {
  complaint: ComplaintsDataCollectionItemFragment
}

const ComplaintOverview: React.FC = () => {
  const { complaint } = useOutletContext<OutletContext>()

  if (!complaint) throw new Error('Complaint not found')

  const { messages, loading } = useComplaintMessages({
    complaintId: complaint.id,
    onlyFirst: true,
  })

  const firstMessage = messages[0]
  const description = firstMessage?.text

  const firstMessageFiles =
    firstMessage?.messagefilesConnection?.edges?.map((edge) => edge.node) || []

  const filesValue = firstMessageFiles.length > 0 && (
    <Box gap="s4">
      {firstMessageFiles.map((file, index) => (
        <AttachmentBox key={index} name={file.filename} path={file.path} />
      ))}
    </Box>
  )

  const options = [
    {
      label: i18n.t('complaints.overview.description'),
      value: loading ? i18n.t('common.loading') : description,
    },
    ...(firstMessageFiles.length > 0
      ? [
          {
            label: i18n.t('complaints.overview.files'),
            value: loading ? i18n.t('common.loading') : filesValue,
          },
        ]
      : []),
  ]

  return (
    <Box gap="s40" height="full">
      <Box gap="s32" justifyContent="flexStart">
        {options.map((option) => (
          <Box key={option.label} gap="s8" paddingRight="s24">
            <Text.Normal size="300" color="grey1000" weight="medium">
              {option.label}
            </Text.Normal>
            {typeof option.value !== 'string' ? (
              option.value
            ) : (
              <Text.Normal size="200" color="grey1000" overflowWrap>
                {option.value}
              </Text.Normal>
            )}
          </Box>
        ))}
      </Box>
      <InternalNotes complaintId={complaint.id} />
    </Box>
  )
}

export default ComplaintOverview
